export default "__VITE_ASSET__D8G0DiTC__"